import React, { useState } from "react";
import { Layout, Tabs } from "antd";
import HolidaysTab from "./tabs/HolidaysTab";
import TariffTab from "./tabs/TariffTab";
import WorkingHoursTab from "./tabs/WorkingHoursTab";
import PermissionRender from "../../components/PermissionRender";

const { Content } = Layout;

function ConfigurationManager() {
  const [activeTab, setActiveTab] = useState("1");

  const tabItems = [
    {
      key: "1",
      label: "Jours Fériés",
      children: (
        <PermissionRender
          requiredPermission={["configuration_manager", "holidays"]}
        >
          <HolidaysTab />
        </PermissionRender>
      ),
    },
    {
      key: "2",
      label: "Tarification",
      children: (
        <PermissionRender
          requiredPermission={["configuration_manager", "tariff"]}
        >
          <TariffTab />
        </PermissionRender>
      ),
    },
    {
      key: "3",
      label: "Horaires",
      children: (
        <PermissionRender
          requiredPermission={["configuration_manager", "working_hours"]}
        >
          <WorkingHoursTab />
        </PermissionRender>
      ),
    },
  ];

  return (
    <Layout className="min-h-screen">
      <Content className="py-6 sm:px-6 lg:px-8">
        <Tabs 
          activeKey={activeTab} 
          onChange={setActiveTab}
          items={tabItems}
        />
      </Content>
    </Layout>
  );
}

export default ConfigurationManager;
